/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
    Grid,
    Row,
    Column,
    Keyboard,
    Button,
    Heading,
    Form,
    FormInput,
    cls,
    HeaderCompound
} from 'packages/components';
import { connect } from 'react-redux';
import Translator from '../../requests/apa/Translator';
import { autobind } from 'packages/core/lib';
import { PAYMENT_HUB_FIJA } from '../utils/constants';
import { showModal, AAF_MODAL_SUCCESS_SUSCRIPTION } from '../../actions/modal';
import { apiPaywayConfirm, onPaymetSuccess, showError, getWorkflow, getNumberLength, setInitialFocus, onFocusMultipleElements, isModalHide } from '../utils/Utils';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import Assets from '../../requests/apa/Asset';
import Device from '../../devices/device';
import Spinner from '../../components/Spinner';
import './_styles.scss';
import { setMetricsEvent } from '../../actions/metrics';
import Utils, { enablePaymentMethodExperience } from 'src/utils/Utils';
import { COMPONENT_PLAN_SELECTOR, METODO_DE_PAGO, LABER_CANCELAR_MEDIO_DE_PAGO_SELECCIONADO } from '../../packages/components/lib/utils/constants';


interface IHubFija {
    form: {
        number: string;
        document: string;
    };
    errorFromBackend: string;
    valid: boolean;
    showTooltipSuccess: boolean;
    pbi: any;
    worflowstart: any;
    selectedPaymentMethod: string;
    isLoading: boolean;
    activeElement: string;
    element: any;
}

class HubFija extends Component<RouteComponentProps, IHubFija> {
    public textNext: string = Translator.get('hubfijogate_access_option_button_next', 'SIGUIENTE');
    public textCancel: string = Translator.get(
        'hubfijogate_access_option_button_cancel',
        'CANCELAR'
    );
    public titleForm: string = Translator.get('hubfijogate_access_title_label', 'Telefonía Fija');
    public stepText: string = Translator.get('top_head_step_3_label', 'PASO 3 DE 3');
    private isValidForm: boolean;
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    private from: string = '';

    constructor(props: RouteComponentProps) {
        super(props);
        const { location: { state = {} } = {} } = props || {};
        this.from = state?.from;
        this.state = {
            form: {
                number: '',
                document: '',
            },
            errorFromBackend: '',
            valid: false,
            showTooltipSuccess: false,
            pbi: {},
            worflowstart: {},
            selectedPaymentMethod: '',
            isLoading: false,
            activeElement: '',
            element: ''
        };
    }

    public componentDidMount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
        const pbi =
            this.props &&
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.pbi;
        const worflowstart =
            this.props &&
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.worflowstart;
        const selectedPaymentMethod = this.props.location.state.method;
        if (pbi && worflowstart) {
            this.setState({ pbi, worflowstart, selectedPaymentMethod });
        }
        if (isModalHide()) {
            setInitialFocus('.aaf_form-group-input-element .aaf_focusable', false);
        }
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
    }

    public componentDidUpdate(): void {
        this.onFocus();
    }

    public enterUpHandler = (e: any) => {
        const el: any = e.target;
        if (el.className.includes('aaf_focusable')) {
            this.setState({ element: e.target });
        }
    };

    @autobind
    private handleChange(value: string, type: string, obj: any): void {
        const { form } = this.state;
        const { $form: { activeField } } = obj['context'];
        this.isValidForm = value !== '';
        this.setState({ activeElement: activeField, form: { ...form, [type]: value } } as IHubFija);
    }

    private handleSubmit = (): void => {
        const { showModal } = this.props;
        const {
            worflowstart,
            worflowstart: {
                contentInfo: { contentImageMedium },
            },
            form: { number, document },
            pbi,
            pbi: { banner, producttype, currency, price, family, isSubscription, groupId },
            selectedPaymentMethod,
        } = this.state;
        const wfs = getWorkflow(selectedPaymentMethod, worflowstart);
        const assetName = `${banner}_${producttype}`;
        const information = Translator.get(
            `Checkout_Transaccion_TextoDescripcion_${producttype}`, '');
        const bonus = Translator.get(`bonus_${producttype}`);
        let cb = isSubscription ? (resp: object) => this.redirectAddon(resp) : () => this.redirectVCard(groupId);

        if (number && document) {
            this.setState({ isLoading: true});
            apiPaywayConfirm({
                pbi,
                wfs,
                formParams: { numberField: number, document, payway: selectedPaymentMethod },
            })
                .then((resp) => {
                    this.setState({ isLoading: false});
                    const { paymentMethodData: { account }, end_date: { day, month, year } } = resp.response;
                    //TODO: month viene en Ingles con tres caracteres, se debe parsear a su correspondiente texto en español
                    const payDate = `${day} ${month} ${year}`;
                    const modal = {
                        modalType: AAF_MODAL_SUCCESS_SUSCRIPTION,
                        modalProps: {
                            data: {
                                total: `${currency}${price}`,
                                days: bonus,
                                content: information,
                                payment_method: account,
                                next_pay: payDate,
                                img_large: contentImageMedium,
                                providerImage: Assets.get(assetName),
                            },
                            callback: () => {
                                onPaymetSuccess(resp, pbi, wfs, selectedPaymentMethod, cb);
                            },
                            payment_methods_experience: enablePaymentMethodExperience()
                        },
                    };
                    showModal(modal);
                })
                .catch((err) => {
                    showError(err);
                    this.setState({ isLoading: false});
                });
        }
    };

    private redirectAddon(resp: any): void {
        const { history, nodes } = this.props;
        const { response: { node_id = '' } = {} } = resp || {};
        let nodeString: string = '';
        const filterNodes = nodes.filter((value: any) => value.code === 'playandgo');
        const resultChilds = filterNodes.map((res: any) => {
            const childsValue = res.childs;
            return childsValue;
        });

        for (let index = 0; index < resultChilds.length; index++) {
            const element = resultChilds[index];

            element.map((resId: any) => {
                if (resId.id === node_id) {
                    return nodeString = resId.code;
                }
            });
        }

        this.setState({ isLoading: false });
        // TODO: Falta llave de metadata para obtener el nodo que le corresponde al addon
        const node = 'pandg_hbo';
        history.replace(`/node/${nodeString ? nodeString : 'homeuser'}`);
    }

    private redirectVCard(groupId?: string): void {
        const { history } = this.props;
        this.setState({ isLoading: false });
        history.replace(`/vcard/${groupId}`);
    }

    private hadleCancel = (): void => {
        const { history } = this.props;
        Utils.sendMetric(this.props, COMPONENT_PLAN_SELECTOR, METODO_DE_PAGO, LABER_CANCELAR_MEDIO_DE_PAGO_SELECCIONADO);
        history.goBack();
    };

    @autobind
    private handleBack(): void {
        const { history } = this.props;
        history.goBack();
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW') {
            this.handleBack();
        }
    }

    @autobind
    private onFocus(): void {
        const { element } = this.state;
        let activeDoc: boolean = false;
        let activeTelefono: boolean = false;
        const numberElments = document.getElementsByClassName('aaf_focusable');
        if (numberElments.length > 1) {
            activeDoc = true;
            if (element.id === 'telefono') {
                activeDoc = false;
                activeTelefono = true;
            }
        }

        onFocusMultipleElements([{ id: 'document', activeElement: activeDoc }, { id: 'telefono', activeElement: activeTelefono }]);
    }

    public render(): JSX.Element {
        const { valid, errorFromBackend, showTooltipSuccess, isLoading } = this.state;
        if (isLoading) return <Spinner className ={cls(`${PAYMENT_HUB_FIJA}-spinner`)} loadingMessage='' />;
        return (
            <Grid className={Device.getDevice().getPlatform()}>
                <HeaderCompound
                    disabled
                    align='right'
                    onClick={this.handleBack}
                    textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                    icon={`${Assets.get('top_head_option_back')}`}
                    onFocus={this.onFocus}
                />
                <Row>
                    <Column lg={12}>
                        <Heading size={2} className={cls(`${PAYMENT_HUB_FIJA}-title`)}>
                            {this.from && this.from === 'plan-selector' ? this.stepText : ''}
                        </Heading>
                    </Column>
                </Row>
                <Row>
                    <Form id="payment-hubfija-form">
                        <Column lg={6} className={cls(`${PAYMENT_HUB_FIJA}-column-keyboard`)}>
                            <Keyboard id="Keyboard" onFocus={this.onFocus} />
                        </Column>
                        <Column lg={6} className={cls(`${PAYMENT_HUB_FIJA}-column-inputs`)}>
                            <Row className={cls(`${PAYMENT_HUB_FIJA}-row-inputs`)}>
                                <Column lg={12}>
                                    <Heading
                                        size={1}
                                        className={cls(`${PAYMENT_HUB_FIJA}-title-form`)}
                                    >
                                        {this.titleForm}
                                    </Heading>
                                </Column>
                                <Row className={cls(`${PAYMENT_HUB_FIJA}-column-input`)}>
                                    <Column lg={12}>
                                        <FormInput
                                            focusWhenMount
                                            id="document"
                                            type="text"
                                            name="document"
                                            onChange={(e, obj) => this.handleChange(e, 'document', obj)}
                                            placeholder={Translator.get(
                                                'hubfijogate_idNumber_placeHolder_label',
                                                'Ingresa tu Cédula'
                                            )}
                                            validInput={valid}
                                        />
                                    </Column>
                                    <Column lg={12}>
                                        <FormInput
                                            id="telefono"
                                            type="mobile"
                                            name="telefono"
                                            onChange={(e, obj) => this.handleChange(e, 'telefono', obj)}
                                            errorFromBackend={errorFromBackend}
                                            showTooltipSuccess={showTooltipSuccess}
                                            placeholder={Translator.get(
                                                'hubfijogate_phoneNumber_placeHolder_label',
                                                'Ingresa tu teléfono '
                                            )}
                                            validInput={valid}
                                            /*maxLength={getNumberLength()}*/
                                        />
                                    </Column>
                                </Row>
                                <Column lg={12}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="primary"
                                        disabled={!this.isValidForm}
                                        className={cls(
                                            `focusable`,
                                            `${PAYMENT_HUB_FIJA}-button-next`
                                        )}
                                        onClick={this.handleSubmit}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.textNext}
                                    </Button>
                                </Column>
                                <Column lg={12} className={cls(`${PAYMENT_HUB_FIJA}-column-next`)}>
                                    <Button
                                        activate
                                        type="button"
                                        className={cls(
                                            `focusable`,
                                            `${PAYMENT_HUB_FIJA}-button-cancel`
                                        )}
                                        onClick={this.hadleCancel}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.textCancel}
                                    </Button>
                                </Column>
                            </Row>
                        </Column>
                    </Form>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal,
    setMetricsEvent
};

export default connect(null, mapDispatchToProps)(HubFija);



// WEBPACK FOOTER //
// ./src/payments/HubFija/index.tsx